import React, {useState, useEffect} from 'react'
import { useParams } from 'react-router-dom'
import { ThemeContext } from '../../Context/ThemeContext/ThemeContext'
import { db } from '../../Firebase/firebase'
import LoadingIcon from '../../LoadingIcon/LoadingIcon'
import Post from '../../Reuable/Post/Post'

import './UserProfilePosts.css'

const UserPosts = () => {
  const { userName } = useParams()
  const { isLight } = React.useContext(ThemeContext)
  
  const [posts, setPosts] = useState([])
  const [loading, isLoading] = useState(true)

  useEffect(() => {
    isLoading(true)
    db.collection('posts').where("userName", "==", userName).orderBy("createdAt","desc").get()
      .then(snapshot => {
        setPosts(snapshot.docs)
        isLoading(false)
      })
  }, [])
  return (
    <section className={`user-posts ${isLight ? "" : "dark"}`}>
      {
        loading ? (
          <div className="loading-icon-container">
            <LoadingIcon />
          </div>
        ) : (
          posts.map(post => {
            return(
              <div className="user-posts__post">
                <Post id={post.id} props={post.data()}/>
              </div>
            )
          })
        )
      }
      
    </section>
  )
}

export default UserPosts



